import * as React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { getMenuNavigationProps, isActive } from '../SidebarMenuItem.utils';
import { Flyout, FlyoutNav } from './FlyoutMenu.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultElement = 'div';
function FlyoutMenu(props) {
  const {
    title,
    pathname,
    links,
    onLinkClick
  } = props;
  if (links) {
    return /*#__PURE__*/_jsxs(FlyoutNav, {
      className: "sidebar-flyout",
      children: [/*#__PURE__*/_jsx("div", {
        className: "sidebar-flyout__title",
        children: title
      }), /*#__PURE__*/_jsx("nav", {
        children: Object.values(links).map(link => {
          const {
            as: LinkComponent = Link,
            className,
            decorator,
            ...linkProps
          } = getMenuNavigationProps({
            pathname,
            link,
            onClick: onLinkClick
          });
          return /*#__PURE__*/_jsxs(LinkComponent, {
            className: clsx(className, 'sidebar-flyout__sublink', isActive(link, pathname) && 'active'),
            ...linkProps,
            children: [link.label, decorator && /*#__PURE__*/_jsx("div", {
              className: "sidebar-flyout__decorator",
              children: decorator
            })]
          }, link.label);
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Flyout, {
    className: "sidebar-flyout",
    children: /*#__PURE__*/_jsx("div", {
      className: "sidebar-flyout__title",
      children: title
    })
  });
}
export default FlyoutMenu;